import { useQueryState, parseAsStringLiteral, parseAsString } from 'nuqs';

export function useActiveHealthTab() {
  const [activeTab, setActiveTab] = useQueryState(
    'tab',
    parseAsStringLiteral(['overview', 'services', 'data', 'messaging']).withDefault('overview'),
  );

  return { activeTab, setActiveTab };
}

export function useScrollTo() {
  const [scrollTo, setScrollTo] = useQueryState('scrollTo', parseAsString);
  return { scrollTo, setScrollTo };
}

const DRAWERS = ['campaigns', 'data-alerts'] as const;

export function useTableDrawer(drawer: (typeof DRAWERS)[number]) {
  const [isDrawerOpen, setIsDrawerOpen] = useQueryState('drawer', parseAsStringLiteral(DRAWERS));

  return { isDrawerOpen: isDrawerOpen === drawer, setIsDrawerOpen };
}
